import { Form } from '@mairistem/composants';

import { useUpdateEffect } from '@mairistem/tools';
import React from 'react';

import type { CarteBancaireType } from '@/types';

import Montant from './Montant';

interface CarteBancaireProps {
  numero: string;
  montant: number;
  disabled: boolean;
  reste: number;
  onChange: (value: CarteBancaireType, complet: boolean) => void;
  onError?: (error: string) => void;
}

const CarteBancaire = (props: CarteBancaireProps) => {
  const { numero: numeroProps, montant: montantProps, disabled, reste, onChange, onError } = props;

  const [numero, setNumero] = React.useState<string>(numeroProps || '');
  const [montant, setMontant] = React.useState<number>(montantProps || 0);

  const handleChange = (value, setter) => {
    setter(value);
  };

  useUpdateEffect(() => {
    if (!disabled) {
      onChange(
        {
          ...(numero !== '' && { numero }),
          ...(montant !== 0 && { montant }),
        },
        montant > 0,
      );
    }
  }, [disabled, numero, montant]);

  useUpdateEffect(() => {
    if (montant !== 0 && montant > reste && onError) {
      onError('Le montant ne peut pas être supérieur au reste');
    }
  }, [montant, reste]);

  return (
    <Form.Group style={{ marginTop: 0, marginBottom: 0 }}>
      <Form.Input
        disabled={disabled}
        autoFocus={!disabled}
        maxLength={6}
        value={numero}
        label="N° du ticket"
        inline
        placeholder="123456"
        style={{ width: 100 }}
        onChange={(e, { value }) => handleChange(value, setNumero)}
        input={{ 'data-testid': 'numeroCarteBancaire' }}
      />
      <Montant
        data-testid="montantCarteBancaire"
        disabled={disabled}
        reste={reste}
        montant={montant}
        onChange={setMontant}
      />
    </Form.Group>
  );
};

export default CarteBancaire;
